/**
 * Volume Discount Tiers v4 for Kingbriefs
 * Works on ALL product pages — with or without Appstle subscription widget.
 * - With Appstle: shows after widget, hides when subscription selected
 * - Without Appstle: shows before qty/add-to-cart, always visible
 */
(function() {
  'use strict';

  var VOLUME_TIERS = [
    { minQty: 3, discount: 15 },
    { minQty: 5, discount: 20 }
  ];

  var tiersContainer = null;
  var currentBasePrice = 0;
  var hasAppstle = false;

  function getBasePrice() {
    /* Try Appstle one-time price */
    var oneTimeWrapper = document.querySelector('.appstle_one_time_details_wrapper');
    if (oneTimeWrapper) {
      var priceEl = oneTimeWrapper.querySelector('[class*="price"]');
      if (priceEl) {
        var match = priceEl.textContent.match(/\$([\d.]+)/);
        if (match) return parseFloat(match[1]);
      }
    }

    /* Try product price display on page */
    var priceSelectors = [
      '.product__price .price-item--regular',
      '.product__price .price-item--sale',
      '.product__price .money',
      '.price__regular span:not(.visually-hidden)',
      '.price__sale .price-item--sale',
      '.price .money'
    ];
    for (var p = 0; p < priceSelectors.length; p++) {
      var priceDisplay = document.querySelector(priceSelectors[p]);
      if (priceDisplay) {
        var m = priceDisplay.textContent.match(/\$([\d.]+)/);
        if (m) return parseFloat(m[1]);
      }
    }

    /* Try product JSON (multiple possible containers) */
    var jsonSelectors = ['[data-product-json]', 'script[type="application/json"][data-product]', 'script[type="application/json"]'];
    for (var j = 0; j < jsonSelectors.length; j++) {
      var jsonEls = document.querySelectorAll(jsonSelectors[j]);
      for (var k = 0; k < jsonEls.length; k++) {
        try {
          var product = JSON.parse(jsonEls[k].textContent);
          if (product.price) return product.price / 100;
          if (product.variants && product.variants[0]) return product.variants[0].price / 100;
        } catch(e) {}
      }
    }

    /* Try meta tag */
    var meta = document.querySelector('meta[property="product:price:amount"]');
    if (meta) return parseFloat(meta.content);

    /* Try any visible price on the page */
    var anyPrice = document.querySelector('.price__regular .price-item, .price .money, .product-single__price');
    if (anyPrice) {
      var m2 = anyPrice.textContent.match(/\$([\d.]+)/);
      if (m2) return parseFloat(m2[1]);
    }

    return 0;
  }


  // ── New Customer Banner ──────────────────────────────────
  function createNewCustomerHTML(basePrice) {
    return (
      '<div class="vd-banner vd-banner--new-member" id="volume-discount-tiers">' +
        '<div class="vd-banner__header">' +
          '<span class="vd-banner__icon">🎁</span>' +
          '<span class="vd-banner__title">NEW MEMBER EXCLUSIVE</span>' +
        '</div>' +
        '<div class="vd-banner__tiers">' +
          '<div class="vd-row">' +
            '<span class="vd-row__desc">Buy 3 Get 1 Free</span>' +
            '<span class="vd-row__code">NEWCUSTOMER</span>' +
          '</div>' +
          '<div class="vd-row__note">Add 4 to cart &middot; Enter code at checkout</div>' +
          '<div class="vd-row">' +
            '<span class="vd-row__desc">Buy 5 Get 2 Free</span>' +
            '<span class="vd-row__code">NEWCUSTOMER2</span>' +
          '</div>' +
          '<div class="vd-row__note">Add 7 to cart &middot; Enter code at checkout</div>' +
        '</div>' +
      '</div>'
    );
  }
  // ─────────────────────────────────────────────────────────

  function createTiersHTML(basePrice) {
    var rowsHTML = '';
    VOLUME_TIERS.forEach(function(tier) {
      var pricePerUnit = basePrice * (1 - tier.discount / 100);
      rowsHTML +=
        '<div class="vd-row">' +
          '<span class="vd-row__desc">Buy ' + tier.minQty + '+, save <strong>' + tier.discount + '%</strong></span>' +
          '<span class="vd-row__price"><del class="vd-row__original-price">$' + basePrice.toFixed(2) + '</del> $' + pricePerUnit.toFixed(2) + '/pair</span>' +
        '</div>';
    });

    return '<div class="vd-banner" id="volume-discount-tiers">' +
      '<div class="vd-banner__header">' +
        '<span class="vd-banner__icon">\uD83C\uDFF7\uFE0F</span>' +
        '<span class="vd-banner__title">Buy More Save More</span>' +
        '<span class="vd-banner__auto">\u2713 Auto-applied at checkout</span>' +
      '</div>' +
      '<div class="vd-banner__tiers">' + rowsHTML + '</div>' +
    '</div>';
  }

  function isOneTimeSelected() {
    if (!hasAppstle) return true; /* No Appstle = always show */
    var radios = document.querySelectorAll('[name="appstle_selling_plan"], [name="selling_plan"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        return radios[i].value === '' || radios[i].value === '0';
      }
    }
    return true;
  }

  function updateVisibility() {
    if (!tiersContainer) return;
    tiersContainer.style.display = isOneTimeSelected() ? 'block' : 'none';
  }

  function findInjectionPoint() {
    /* Priority 1: After Appstle subscription widget */
    var appstleWidget = document.querySelector('[id^="appstle_subscription_widget"]');
    if (appstleWidget) {
      hasAppstle = true;
      return { anchor: appstleWidget, position: 'afterend' };
    }

    /* Priority 2: Before quantity selector */
    var qtyInput = document.querySelector('.product-form__quantity, .product-form__input.product-form__quantity, quantity-input, .product__quantity, .quantity__wrapper');
    if (qtyInput) {
      /* Try to get the parent row if qty is inline with add-to-cart */
      var qtyParent = qtyInput.closest('.product__buy-buttons, .product-form__buttons');
      if (qtyParent) return { anchor: qtyParent, position: 'beforebegin' };
      return { anchor: qtyInput, position: 'beforebegin' };
    }

    /* Priority 3: Before add to cart button */
    var addBtn = document.querySelector('.product-form__submit, .product-form__cart-submit, [type="submit"][name="add"], button[name="add"]');
    if (addBtn) {
      var btnContainer = addBtn.closest('.product-form__buttons, .product__submit');
      if (btnContainer) return { anchor: btnContainer, position: 'beforebegin' };
      return { anchor: addBtn, position: 'beforebegin' };
    }

    /* Priority 4: Before buy buttons area */
    var buyButtons = document.querySelector('.product__buy-buttons, .product-form');
    if (buyButtons) {
      return { anchor: buyButtons, position: 'beforebegin' };
    }

    return null;
  }

  function injectTiers() {
    if (document.querySelector('[data-kb-member-offer]')) return;
    if (document.getElementById('volume-discount-tiers')) return;

    var basePrice = getBasePrice();
    if (basePrice <= 0) return;
    currentBasePrice = basePrice;

    var point = findInjectionPoint();
    if (!point) return;

    var html = window.KB_IS_NEW_CUSTOMER
      ? createNewCustomerHTML(basePrice)
      : createTiersHTML(basePrice);
    point.anchor.insertAdjacentHTML(point.position, html);
    tiersContainer = document.getElementById('volume-discount-tiers');
    updateVisibility();
  }

  function observeChanges() {
    document.addEventListener('change', function(e) {
      if (e.target.name === 'appstle_selling_plan' || e.target.name === 'selling_plan' ||
          (e.target.closest && e.target.closest('[class*="appstle"]'))) {
        setTimeout(updateVisibility, 50);
      }
    });
    document.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('.appstle_subscription_wrapper_option, .appstle_radio_label')) {
        setTimeout(updateVisibility, 100);
      }
    });
  }

  /* Listen for variant changes to update prices */
  function observeVariantChanges() {
    /* Watch for price changes in the DOM */
    var priceEl = document.querySelector('.product__price');
    if (priceEl) {
      new MutationObserver(function() {
        var newPrice = getBasePrice();
        if (newPrice > 0 && newPrice !== currentBasePrice) {
          currentBasePrice = newPrice;
          var existing = document.getElementById('volume-discount-tiers');
          if (existing) existing.remove();
          tiersContainer = null;
          injectTiers();
        }
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  function isProductPage() {
    return /\/products\//.test(window.location.pathname);
  }

  function init() {
    if (!isProductPage()) return;
    if (document.querySelector('[data-kb-member-offer]')) return;

    var attempts = 0;
    var maxAttempts = 80; /* 8 seconds */
    var checkInterval = setInterval(function() {
      attempts++;

      /* Check if Appstle widget loaded */
      var appstleWidget = document.querySelector('[id^="appstle_subscription_widget"]');
      if (appstleWidget) {
        clearInterval(checkInterval);
        hasAppstle = true;
        setTimeout(function() {
          injectTiers();
          observeChanges();
          observeVariantChanges();
        }, 300);
        return;
      }

      /* After 3 seconds, if no Appstle, inject anyway (for socks / non-subscription products) */
      if (attempts >= 30) {
        /* Check if we can find an injection point */
        var point = findInjectionPoint();
        if (point) {
          clearInterval(checkInterval);
          hasAppstle = false;
          injectTiers();
          observeVariantChanges();
          return;
        }
      }

      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        /* Last attempt */
        hasAppstle = false;
        injectTiers();
        observeVariantChanges();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

